export default __webpack_public_path__ + "static/media/calendaredit.6079c3c0.svg";